import { Component, Renderer2, ViewChild, ElementRef, EventEmitter, Output } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { HomeService } from '../../../../services/home.service';
import { Stockitem } from '../../../../interfaces/stockitem';
import { MatSelect, MatSelectChange } from '@angular/material/select';
import { SelectedProductDetail } from '../../../../interfaces/addorder';
import { UserService } from '../../../../services/user';
import { DeviceDetectorService } from '../../../../services/device-detector.service';
import { SuppliesService } from '../../../../services/supplies';
import { OrdersService } from '../../../../services/orders';
@Component({
  selector: 'app-supplies-request',
  templateUrl: './supplies-request.component.html',
  styleUrl: './supplies-request.component.scss'
})
export class SuppliesRequestComponent {
  @ViewChild('productSelect', { static: false }) productSelect!: ElementRef;
  quantity!: number;
  price!: number;
  supplier_name!: string;
  type: any = "0";
  payed!: any;
  contentReady: boolean = false;
  installment_period!: any;
  installment_price!: any;
  item!: string[];
  qtys!: string[];
  not_payed!: any;
  note!: string;
  arrayofitems: any = [];
  arrayofqty: any = [];
  arrayofprices: any = [];
  arrayofoldqty: any = [];
  arrayofoldprices: any = [];
  arrayofids: any = [];
  data!: FormGroup;
  isMobile: boolean = false;
  productname: Stockitem[] = [];
  isAr: boolean = false;
  accounttype: any;
  thisUserId: any;
  selectedProduct: any = null;
  installment: any;
  credit: any;
  selectedProductsDetails: SelectedProductDetail[] = [];
  providers = new FormControl();
  allProviders: any[] = this.productname;
  users!: any;
  isAdmin!: any;
  isSubAdmin!: any;
  warehouseid!: any;
  searchValue = '';
  filteredProviders: any[] = this.productname;
  submitted = false;
  types = [
    { id: 0, name: 'cash', nameAr: 'كاش' },
    { id: 1, name: 'credit', nameAr: 'بالآجل' },
    { id: 2, name: 'installment', nameAr: 'قسط' }
  ];
  @ViewChild('mySelect') mySelect!: MatSelect;
  phonenumber!: string;
  @Output() selectionChange: EventEmitter<MatSelectChange> | undefined
  constructor(
    private router: Router,
    private renderer: Renderer2,
    private _suppliesService: SuppliesService,
    private fb: FormBuilder,
    private _orderService: OrdersService,
    private deviceService: DeviceDetectorService,
    private _userService: UserService
  ) { }
  token = localStorage.getItem('token');
  ngOnInit() {
    this.warehouseid = localStorage.getItem("posId");
    this.isMobile = this.deviceService.isMobileDevice();
    this.isAr = localStorage.getItem("language") == "ar";
    this.accounttype = String(this.checkAccountType());
    this.getUserId();
    this.getAllStockData();
    this.initiate();
  }
  checkAccountType() {
    this._userService.getAccountType().subscribe({
      next: (data) => {
        this.accounttype = data['user_type'];
        this.isSubAdmin = this.accounttype == '6';
        this.isAdmin = this.accounttype == '1' || this.accounttype == "10";
      },
      error: (error) => console.error(error),
    });
    return this.accounttype;
  }
  onSearchChange(event: any) {

    const value = event.target.value.toLowerCase();

    this.searchValue = value;

    this.filteredProviders = this.productname.filter(p =>
      p.name_ar.toLowerCase().includes(value)
    );

  }
  addProduct(event: any) {

    const product = event.option.value;

    const exists = this.selectedProductsDetails.find(
      p => p.product.id === product.id
    );

    if (exists) return;

    this.selectedProductsDetails.push({
      product,
      quantity: 1,
      price: product.price
    });

    this.searchValue = '';

  }
  removeProduct(index: number) {
    this.selectedProductsDetails.splice(index, 1);
  }
  getUserId() {
    this._userService.getUserId().subscribe({
      next: (data) => {
        this.thisUserId = data['user_id'];
      },
      error: (error) => console.error(error),
    });
  }
  openSelect() {
    this.mySelect.open();
  }
  initiate() {
    this.data = this.fb.group({
      supplier_name: ['', Validators.required],
      type: ['0', Validators.required],
      payed: [''],
      not_payed: [''],
      installment_period: [''],
      installment_price: [''],
      item: [''],
      createby: [''],
      price: [''],
      quantity: [''],
      delivery_fees: [''],
      note: [''],
      arrayofids: [''],
      phonenumber: ['', Validators.required],
    });
  }
  shouldShowError(controlName: string): boolean {
    const control = this.data?.get(controlName);
    return !!control && control.invalid && (control.touched || this.submitted);
  }

  shouldShowProductsError(): boolean {
    return this.submitted && this.selectedProductsDetails.length === 0;
  }

  shouldShowProductRowError(item: SelectedProductDetail): boolean {
    return this.submitted && (!Number(item.quantity) || Number(item.quantity) <= 0 || !Number(item.price) || Number(item.price) <= 0);
  }

  shouldShowConditionalError(controlName: string): boolean {
    if (!this.submitted) {
      return false;
    }

    if (this.credit) {
      return (controlName === 'payed' && !this.payed) || (controlName === 'not_payed' && !this.not_payed);
    }

    if (this.installment) {
      return (controlName === 'installment_period' && !this.installment_period) ||
        (controlName === 'installment_price' && !this.installment_price);
    }

    return false;
  }

  getErrorMessage(controlName: string, label: string): string {
    const control = this.data?.get(controlName);

    if (control?.errors?.['required']) {
      return this.isAr ? `${label} مطلوب` : `${label} is required`;
    }

    return this.isAr ? `${label} مطلوب` : `${label} is required`;
  }

  getMissingRequiredCount(): number {
    let count = 0;

    if (this.data) {
      count += Object.keys(this.data.controls).filter((controlName) => {
        const control = this.data.get(controlName);
        return control?.hasError('required');
      }).length;
    }

    if (this.selectedProductsDetails.length === 0) {
      count++;
    }

    count += this.selectedProductsDetails.filter((item) =>
      !Number(item.quantity) || Number(item.quantity) <= 0 || !Number(item.price) || Number(item.price) <= 0
    ).length;

    if (this.credit) {
      if (!this.payed) count++;
      if (!this.not_payed) count++;
    }

    if (this.installment) {
      if (!this.installment_period) count++;
      if (!this.installment_price) count++;
    }

    return count;
  }

  private validateBeforeSubmit(): boolean {
    this.submitted = true;

    const hasInvalidProducts = this.selectedProductsDetails.some((item) =>
      !Number(item.quantity) || Number(item.quantity) <= 0 || !Number(item.price) || Number(item.price) <= 0
    );
    const hasMissingCredit = this.credit && (!this.payed || !this.not_payed);
    const hasMissingInstallment = this.installment && (!this.installment_period || !this.installment_price);

    if (this.data.invalid || this.selectedProductsDetails.length === 0 || hasInvalidProducts || hasMissingCredit || hasMissingInstallment) {
      this.data.markAllAsTouched();

      Swal.fire({
        icon: 'warning',
        title: this.isAr ? 'تأكد من بيانات طلب التوريد' : 'Please check supply request data',
        text: this.isAr ? 'راجع الرسائل تحت الحقول المطلوبة أو غير الصحيحة' : 'Review the messages below the required or invalid fields',
        confirmButtonText: this.isAr ? 'تمام' : 'OK',
      });

      return false;
    }

    return true;
  }
  submitSelectedProducts() {
    this.arrayofitems = [];
    this.arrayofids = [];
    this.arrayofprices = [];
    this.arrayofqty = [];
    for (const item of this.selectedProductsDetails) {
      const product = item.product;
      const quantity = item.quantity || 0;
      const enteredPrice = item.price || 0;
      this.arrayofoldprices.push(product.price);
      this.arrayofoldqty.push(product.quantity);
      this.arrayofitems.push(product.name_ar);
      this.arrayofids.push(product.id);
      this.arrayofprices.push(enteredPrice);
      this.arrayofqty.push(quantity);
    }
  }
  dataForm: any;
  appendPostDtata() {
    this.dataForm = new FormData();
    this.dataForm.append('supplier_name', this.supplier_name);
    this.dataForm.append('type', this.isAdmin ? this.type : 0);
    this.dataForm.append('status', "pending");
    this.dataForm.append('note', this.note);
    this.dataForm.append('items[]', this.arrayofitems);
    this.dataForm.append('qtys[]', this.arrayofoldqty);
    this.dataForm.append('prices[]', this.arrayofoldprices);
    this.dataForm.append('new_qtys[]', this.arrayofqty);
    this.dataForm.append('new_price[]', this.arrayofprices);
    this.dataForm.append('product_ids[]', this.arrayofids);
    if (this.payed)
      this.dataForm.append('payed', this.payed);
    if (this.not_payed)
      this.dataForm.append('not_payed', this.not_payed);
    this.dataForm.append('requested_by', this.thisUserId);
    this.dataForm.append('user_last_name', this.thisUserId);
    if (this.installment_period)
      this.dataForm.append('installment_period', this.installment_period);
    if (this.installment_price)
      this.dataForm.append('installment_price', this.installment_price);
    this.dataForm.append('phone_number', this.phonenumber);
    this.dataForm.append('warehouse_id', this.warehouseid);
  }
  onSubmit() {
    if (!this.validateBeforeSubmit()) {
      return;
    }

    this.contentReady = true;
    this.submitSelectedProducts();
    this.appendPostDtata();
    this._suppliesService.supplyRequest(this.dataForm).subscribe({
      next: (res) => {
        Swal.fire({
          icon: 'success',
          title: this.isAr ? "طلبك قيد الانتظار" : 'Request Placed',
          showConfirmButton: false,
          timer: 1500,
        });
        this.contentReady = false;
        if (this.isMobile)
          this.router.navigateByUrl('/suppliespage.mobile');
        else
          this.router.navigateByUrl('/suppliespage');
      },
      error: (err) => {
        Swal.fire({
          icon: 'error',
          title: this.isAr ? "فشل حفط الطلب" : 'Request Failed',
          confirmButtonText: this.isAr ? 'تمام' : 'ok',
        });
        this.contentReady = false;
      },
    });

  }
  getAllStockData() {

    this._orderService.getStocksData(localStorage.getItem("posId")).subscribe({
      next: (data) => {
        this.productname = data.stocks.sort((a: any, b: any) =>
          a.name_ar.localeCompare(b.name_ar, 'ar', { sensitivity: 'base' })
        );

        this.filteredProviders = this.productname;
      },
      error: (error) => console.error(error),
    });
  }
  onInputChange(event: any) {
    this.openSelect();
    const searchInput = event.target.value.toLowerCase();
    const filtered = this.productname.filter(({ name_ar }) =>
      name_ar.toLowerCase().includes(searchInput)
    );
    const selected = this.providers.value || [];
    const merged = [...filtered, ...selected];
    this.filteredProviders = merged.filter(
      (product, index, self) =>
        index === self.findIndex(p => p.id === product.id)
    );
  }
  onProductSelected(event: MatSelectChange) {
    var selectedItems;
    if (event.value) {
      selectedItems = event.value;
    }
    else {
      selectedItems = event;
    }
    this.selectedProductsDetails = selectedItems.map((item: any) => {
      const existing = this.selectedProductsDetails.find(d => d.product.id === item.id);
      return {
        product: item,
        quantity: null,
        price: null
      };
    });
  }
  typeChange(event: any) {
    this.type = event;
    if (event === 1) {
      // Credit
      this.installment = false;
      this.credit = true;
      this.installment_period = null;
      this.installment_price = null;
      console.log(this.type);
    }
    else if (event === 2) {
      // installment

      this.type = 2;
      console.log(this.type);
      this.not_payed = null;
      this.payed = null;
      this.credit = false;
      this.installment = true;
    }
    else {
      console.log(this.type);
      // cash
      this.installment = false;
      this.credit = false;
      this.not_payed = null;
      this.payed = null;
      this.installment_period = null;
      this.installment_price = null;
    }
  }
}
